import React from 'react';
import { FormSlideProps } from '../Objects/interfaces/AppInterface';
import validateEmail from '../Validation/Email';
import { validatePhoneNumber } from '../Validation/Phone';
import useTailwindBrand from '../Theme/useTailwindBrand';
import { ENV_TEACHR, isBrandActive } from '../config/environment.config';
import FormInput from './Ui/FormInput';
import ButtonField from './Ui/ButtonField';
import OptionalFields from './Fields/OptionalFields';

const FormSlide = ({ email, setEmail, phone, setPhone, errors, firstName, setFirstName, lastName, setLastName, onSubmit, loading }: FormSlideProps) => {
    const { common } = useTailwindBrand()
    return (
        <div className="md:w-full min-w-[250px]">
            <p className={`${common.body} pb-4`}>
                Pour ajouter {isBrandActive(ENV_TEACHR) ? "un élève" : "un client"}, seuls son numéro de téléphone et son adresse e-mail sont requis. Si {isBrandActive(ENV_TEACHR) ? "l'élève" : "le client"} finance ses cours lui-même, veuillez renseigner ses informations personnelles.
            </p>
            <div className={`grid md:grid-cols-1 gap-4 ${errors.mail || errors.telephone ? "pt-5 gap-y-8 pb-4" : "pt-0"}`}>
                <FormInput
                    label="Adresse email"
                    type="text"
                    placeholder="Ex: johnxxx@gmail.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    error={errors.mail ? validateEmail(email).message : undefined}
                    required
                />
                <FormInput
                    label="Téléphone"
                    type="tel"
                    placeholder="Ex: 06 XX XX XX XX"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    error={errors.telephone ? validatePhoneNumber(phone) : undefined}
                    required
                />
            </div>
            <p className={`${common.body} py-4`}>Informations complémentaires optionnelles</p>
            <OptionalFields firstName={firstName} setFirstName={setFirstName} lastName={lastName} setLastName={setLastName} />
            <div className="flex gap-x-4 pt-10 py-2 justify-between">
                <ButtonField
                    label="Envoyer"
                    onClick={onSubmit}
                    disabled={loading}
                    loading={loading}
                    loadingPosition='start'
                    className='w-full'
                    variant='contained'
                />
            </div>
        </div>


    );
};

export default FormSlide;